import { AuthProvider } from 'contexts/AuthContext';
import { FullscreenProvider } from 'contexts/FullScreenContext';
import { ToastProvider } from 'contexts/ToastContext';
import { UserProvider } from 'contexts/UserContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'redux.toolkit/store';
import 'styles/variables.css';
import 'styles/global.css';
import { ConnectionStatus } from 'components/NetworkStatus';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistSsoTokenFromUrl } from './utils/ssoToken';

const { REACT_APP_ENV } = process.env;

// Capturer ?token= avant le routeur hash et avant AuthProvider
persistSsoTokenFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <UserProvider>
          <ToastProvider>
            <FullscreenProvider>
              {REACT_APP_ENV !== 'development' && <ConnectionStatus />}
              <App />
            </FullscreenProvider>
          </ToastProvider>
        </UserProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
